// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:20:48

export default {
  "id": "fill-one-line",
  "slug": "fill-one-line",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9e8efe494f36414ca2c9a4b53811960f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9e8efe494f36414ca2c9a4b53811960f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Fill One Line",
      "description": "Dive into the world of fascinating logic and test your mind in an exciting puzzle! Your task is to draw a line across the entire playing field, filling it completely, but keep in mind: there will be obstacles on the way that you need to bypass.\n\nThe game offers many levels, from simple to incredibly difficult, allowing each player to choose a suitable challenge. \n",
      "instructions": "Start from the chosen starting point.\nDraw a line, connecting the cells of the field to fill them.\nAvoid obstacles and plan the route so that the line does not break.\nComplete the level by filling the entire field without gaps.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "block",
        "fill",
        "levels",
        "logic"
      ]
    },
    "zh-CN": {
      "title": "填满一行",
      "description": "深入迷人的逻辑世界，在激动人心的谜题中测试你的大脑！你的任务是绘制一条贯穿整个游戏场的线条，将其完全填满，但请注意：途中会有障碍需要绕过。\n\n游戏提供了许多关卡，从简单到难以置信的困难，让每位玩家都能选择合适的挑战。",
      "instructions": "从选定的起点开始。\n绘制线条，连接场地的单元格以填充它们。\n避开障碍物，规划路线以确保线条不断。\n通过填充整个场地且无空缺来完成关卡。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "方块",
        "填充",
        "关卡",
        "逻辑"
      ]
    },
    "zh-TW": {
      "title": "填滿一行",
      "description": "深入迷人的邏輯世界，在刺激的謎題中挑戰你的智慧！你的任務是畫一條線穿越整個遊戲場地，將其完全填滿，但記住：路途上將會有障礙，你需要迴避它們。\n\n遊戲提供多個等級，從簡單到驚人困難，讓每位玩家都能選擇合適的挑戰。",
      "instructions": "從選定的起始點開始。\n畫一直線，將場地上的單元連接起來以填滿它們。\n避免障礙物並規劃路徑，確保線不會斷裂。\n完成關卡，將整個場地填滿且沒有縫隙。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻塞",
        "填充",
        "關卡",
        "邏輯"
      ]
    },
    "zh-HK": {
      "title": "填滿一行",
      "description": "跳進迷人的邏輯世界，在刺激的謎題中挑戰你的思維！你的任務是在整個遊戲場地中畫一條線，將其完全填滿，但請記住：路上將會有障礙物需要你迴避。\n\n遊戲提供多個難度層次，從簡單到難以置信的困難，讓每位玩家都能選擇合適的挑戰。",
      "instructions": "從選定的起始點開始。\n畫一直線，連接場地中的單元格以填滿它們。\n避免障礙物並規劃路徑，確保線不會斷裂。\n完成等級，通過填滿整個場地且沒有空隙來結束遊戲。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻擋",
        "填滿",
        "關卡",
        "邏輯"
      ]
    },
    "ja": {
      "title": "一列を埋める",
      "description": "興味深いロジックの世界に飛び込み、魅力的なパズルであなたの頭脳を試してみましょう！あなたのタスクは、プレイフィールド全体を完全に埋める線を引くことですが、心に留めておいてください：道には回避する必要がある障害があります。\n\nこのゲームは、単純から驚くほど難しいまでの多くのレベルを提供しており、それぞれのプレイヤーが適切な挑戦を選ぶことができます。",
      "instructions": "選択されたスタートポイントから始めます。\nフィールドのセルを結ぶ線を引きます。\n障害物を避け、線が切れないようにルートを計画します。\nフィールド全体をギャップなく埋めることでレベルを完了します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ブロック",
        "埋める",
        "レベル",
        "ロジック"
      ]
    },
    "ko": {
      "title": "하나의 줄 채우기",
      "description": "놀라운 로직의 세계로 뛰어들고, 흥미진진한 판타지에서 마음을 테스트하세요! 당신의 역할은 전체 플레이 필드를 가득 채우는 선을 그리는 것이지만, 기억하세요: 그 길에 장애물이 있어 이를 뛰어넘어야 합니다.\n\n이 게임은 간단한 것부터 엄청난 난이도의 것까지 많은 레벨을 제공하여 각 플레이어가 적절한 도전을 선택할 수 있습니다.",
      "instructions": "선택된 시작점에서 시작하세요.\n필드의 셀을 연결하여 라인을 그립니다.\n장애물을 피하고 라인이 끊어지지 않도록 경로를 계획하세요.\n격자를 완전히 채우지 않도록 공간이 없이 레벨을 완료하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "블록",
        "채우기",
        "레벨",
        "로직"
      ]
    },
    "fr": {
      "title": "Remplir une ligne",
      "description": "Plongez dans le monde fascinant de la logique et testez votre esprit dans un puzzle excitant ! Votre tâche consiste à dessiner une ligne sur tout le champ de jeu, le remplissant entièrement, mais souvenez-vous : il y aura des obstacles sur votre chemin que vous devez contourner.\n\nLe jeu propose de nombreux niveaux, allant de simples à incroyablement difficiles, permettant à chaque joueur de choisir un défi approprié.",
      "instructions": "Départez du point de départ sélectionné.\nTracez une ligne, reliant les cellules du champ pour les remplir.\nÉvitez les obstacles et planifiez le chemin de sorte que la ligne ne se casse pas.\nTerminez le niveau en remplissant complètement le champ sans lacunes.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "bloquer",
        "remplir",
        "niveaux",
        "logique"
      ]
    }
  }
};
